import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-streaming-indicator.module.scss.js';

const PageStreamingIndicator = () => {
  const streaming = useLlm(state => state.streaming);
  const classNames = getClassNames(style.indicator, {
    [style.streaming]: streaming
  });
  return jsx("div", {
    className: classNames,
    children: jsx("div", {
      className: style.icon
    })
  });
};

export { PageStreamingIndicator };
//# sourceMappingURL=page-streaming-indicator.js.map
